export function getDebugInfo(component: Element): string {
  const { outerHTML } = component
  const idx = outerHTML.indexOf('>')
  if (idx !== -1) {
    return `${outerHTML.slice(0, idx + 1)}`
  }

  return 'unableToParseTag'
}
